import { useAccessManagement } from "@valenzinsights/access-management-component";
import { Button, Grid, useTheme } from "@valenzinsights/core-component";
import { ErrorGroupIconSvg, ValenzLogoIconSvg } from "@valenzinsights/images";
import { logout } from "@valenzinsights/services";

import { useEffect, useRef, useState } from "react";

import { useMsal } from "@azure/msal-react";

export const Error403 = () => {
	const theme = useTheme();
	const { instance } = useMsal();
	const [isBelowMd, setIsBelowMd] = useState(false);
	const containerRef = useRef(null);
	const { profileName } = useAccessManagement();

	useEffect(() => {
		const observer = new ResizeObserver((entries) => {
			for (let entry of entries) {
				const width = entry.contentRect.width;
				setIsBelowMd(width < theme.breakpoints.values.md);
			}
		});

		if (containerRef.current) {
			observer.observe(containerRef.current);
		}

		return () => {
			if (containerRef.current) {
				observer.unobserve(containerRef.current);
			}
		};
	}, [theme.breakpoints.values.md]);

	const classes = {
		root: {
			display: "flex",
			width: "100%",
		},
		footer: {
			height: "5%",
			display: "grid",
			justifyContent: "center",
			alignContent: "center",
		},
		message: {
			fontSize: "32px !important",
			marginBottom: "10px !important",
			fontWeight: "600 !important",
		},
		content: {
			alignItems: "center",
			display: "flex",
		},
		contentImage: {
			display: "flex",
			height: "95%",
			alignItems: "center",
			justifyItems: "center",
		},
		contentContainer: {
			border: "1 solid black",
			display: "grid",
			paddingLeft: "15%",
			justifyContent: "center",
			alignContent: "center",
		},
		errorLogo: {
			width: "100%",
			height: "calc(100vh - 83px)",
			margin: isBelowMd ? "0 auto" : "unset",
			opacity: isBelowMd ? "0.2" : "1",
		},
		link: {
			marginTop: "20px !important",
		},
		appLogo: {
			width: "300px",
			[theme.breakpoints.between("xs", "sm")]: {
				width: "300px",
				margin: "auto auto",
			},
		},
	};

	return (
		<div style={classes.root} ref={containerRef}>
			<Grid container>
				<Grid item sm={12} xs={12} md={12} xl={12} lg={12} style={classes.content}>
					<div style={{ position: "relative", width: "100%" }}>
						<div
							style={{
								position: "absolute",
								width: "100%",
								textAlign: "center",
								top: "0px",
							}}
						>
							<img style={{ width: "200px" }} src={ValenzLogoIconSvg} alt="" />
						</div>
						<img style={classes.errorLogo} src={ErrorGroupIconSvg} />
						<div
							style={{
								position: "absolute",
								top: "0",
								display: "flex",
								flexDirection: "column",
								height: "100%",
								justifyContent: "center",
								paddingLeft: isBelowMd ? "60px" : "150px",
							}}
						>
							<div style={{ fontSize: "40px", fontWeight: "bold" }}>403</div>
							<div style={{ fontSize: "24px", fontWeight: "bold" }}>
								Access Prohibited !
							</div>
							<div>
								{profileName ? (
									<div>
										<span>Hi </span>
										<span
											style={{
												fontSize: theme.typography.h4.fontSize,
												fontWeight: theme.typography.h4.fontWeight,
											}}
										>
											{profileName ?? ""}
										</span>
										{", "}
									</div>
								) : (
									""
								)}
								You don't have permission to access this page.
							</div>
							<div style={{ marginBottom: "10px" }}>Please contact administrator</div>
							<div>
								<Button variant="contained" onClick={() => logout(instance)}>
									Logout
								</Button>
							</div>
						</div>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};
